export default __webpack_public_path__ + "static/media/girlwithflower.569a68b2.svg";